import './index.css';
import {noop} from '../../common/utils';
export default {
    install: noop
};
